import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const PONGOCREATEORLINKACCOUNTMODAL_LEGACY_FIELD_ORDER = [
  "modal_heading"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  pongoCreateOrLinkAccountModalDescriptor: _generatedPongoCreateOrLinkAccountModalDescriptor,
  pongoCreateOrLinkAccountModalModalDefinition,
  pongoCreateOrLinkAccountModalDashboardLayout,
  pongoCreateOrLinkAccountModalConfig,
  pongoCreateOrLinkAccountModalResolveConfig,
  pongoCreateOrLinkAccountModalProperties,
} = doodModalConfig(
  {
    name: "Pongo - Create or link account modal",
    handle: "pongo-create-or-link-account-modal",
    internal_name: "PongoCreateOrLinkAccountModal",
    componentType: 'PongoCreateOrLinkAccountModalComponent',
    category: 'modal',
    description: "Pongo - Create or link account modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "pongo-create-or-link-account-modal",
    allowed_in: ["ModalBlock"],
    sharedFields: {}
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        "label": "Couleur de fond"
      }
    }),
    modal_heading: propertyValue({
      type: 'text',
      value: 'pongo.join-modal-heading',
      options: {
        "label": "Titre de la modale",
        "help": "Clé i18n ou texte affiché en titre. Laisser la valeur par défaut pour le titre Pongo."
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["background_color", "modal_heading"],
          },
        ],
      },
    ],
  })
);

export function pongoCreateOrLinkAccountModalDescriptor(): IBlockDescriptor;
export function pongoCreateOrLinkAccountModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function pongoCreateOrLinkAccountModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedPongoCreateOrLinkAccountModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedPongoCreateOrLinkAccountModalDescriptor, pongoCreateOrLinkAccountModalProperties, fieldOrder);
}

export {
  pongoCreateOrLinkAccountModalModalDefinition,
  pongoCreateOrLinkAccountModalDashboardLayout,
  pongoCreateOrLinkAccountModalProperties,
  pongoCreateOrLinkAccountModalConfig,
  pongoCreateOrLinkAccountModalResolveConfig,
};

export type PongoCreateOrLinkAccountModalConfig = typeof pongoCreateOrLinkAccountModalConfig;
